import { ChangeEvent, FC, useCallback, useLayoutEffect, useMemo, useState } from 'react';
import { Loading, Modal, Table } from '../../../../components';
import { TVeiculoMarca, getAdminVehicleBrands } from '../../../../services';
import { RegistrationPage } from '../../templates';
import { RegistrationEntities, useFilteredItems } from '../../../../utils';
import { TableWrapper } from '../../Registration.styles';
import { useToastStore } from '../../../../stores';

const RegistrationBrands: FC = () => {
	const { setToast } = useToastStore();
	const [loading, setLoading] = useState<boolean>(false);
	const [vehicleBrands, setVehicleBrands] = useState<TVeiculoMarca[]>([]);
	const [openDeleteModal, setOpenDeleteModal] = useState(false);
	const [searchTerm, setSearchTerm] = useState('');
	const { filteredItems, filterLoading } = useFilteredItems({
		items: vehicleBrands,
		searchTerm,
		status: null,
		filterFn: useCallback((item: TVeiculoMarca, searchTerm: string) => {
			let matchesSearchTerm = true;

			if (searchTerm) {
				const matchesName =
					item.veiculoMarca?.toLowerCase().includes(searchTerm.toLowerCase()) ?? false;

				matchesSearchTerm = matchesName;
			}

			return matchesSearchTerm;
		}, []),
	});

	const tableColumns = useMemo(
		() => [
			{ id: 'type', label: 'Tipo' },
			{ id: 'brand', label: 'Marca' },
			{ id: 'fipe', label: 'FIPE' },
			//{ id: 'actions', label: 'Ações' },
		],
		[]
	);

	const rowMapper = useCallback(
		(item: TVeiculoMarca) => ({
			brand: { value: item.veiculoMarca, rawValue: item.veiculoMarca },
			type: { value: item.veiculoTipo?.veiculoTipo, rawValue: item.veiculoTipo?.veiculoTipo },
			fipe: { value: item.codigoMarcaFipe, rawValue: item.codigoMarcaFipe || '' },
			/*
			actions: {
				value: (
					<ActionsContainer>
						<Tooltip title='Editar' placement='top' arrow>
							<Link to=''>
								<Button variant='icon' icon={<EditOutlined fontSize='inherit' />} />
							</Link>
						</Tooltip>
						<Tooltip title='Excluir' placement='top' arrow>
							<div>
								<Button
									variant='icon'
									icon={<DeleteOutlined fontSize='inherit' />}
									onClick={() => setOpenDeleteModal(true)}
								/>
							</div>
						</Tooltip>
					</ActionsContainer>
				),
			},
			*/
		}),
		[]
	);

	const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
		setSearchTerm(e.target.value);
	};

	const handleDelete = () => {};

	const MemoizedTable = useMemo(
		() => <Table paginate columns={tableColumns} rows={filteredItems.map(rowMapper)} />,
		[filteredItems, rowMapper, tableColumns]
	);

	useLayoutEffect(() => {
		const fetchData = async () => {
			setLoading(true);
			try {
				const response = await getAdminVehicleBrands();
				const sorted = (response || []).sort((a, b) => {
					if (a.veiculoMarca! < b.veiculoMarca!) {
						return -1;
					}
					if (a.veiculoMarca! > b.veiculoMarca!) {
						return 1;
					}
					return 0;
				});
				setVehicleBrands(sorted);
			} catch {
				setToast({
					message: 'Erro ao buscar as marcas!',
					variant: 'error',
				});
			} finally {
				setTimeout(() => setLoading(false), 500);
			}
		};

		fetchData();
	}, [setToast]);

	if (loading) return <Loading fullScreen />;

	return (
		<RegistrationPage
			entity={RegistrationEntities.brand}
			searchTerm={searchTerm}
			disableNewButton={true}
			onChange={handleSearchChange}
		>
			<>
				<Modal
					open={openDeleteModal}
					onClose={() => setOpenDeleteModal(false)}
					title='Confirmação!'
					primaryButtonText='Sim'
					secondaryButtonText='Não'
					onPrimaryButtonClick={handleDelete}
					onSecondaryButtonClick={() => setOpenDeleteModal(false)}
				>
					Deseja realmente excluir?
				</Modal>
				<TableWrapper>{filterLoading ? <Loading /> : MemoizedTable}</TableWrapper>
			</>
		</RegistrationPage>
	);
};

export default RegistrationBrands;
